import { SET_PRIVATE_CUSTOMER } from "./types";
import subscriptions from "../services/subscriptions";

export const fetchPrivateCustomer = () => async (dispatch) => {
  const customer = await subscriptions.fetchPrivateCustomer();
  dispatch({ type: SET_PRIVATE_CUSTOMER, payload: { customer } });
};
